import { useQuery } from "@tanstack/react-query";
import { useUpdateDoc, useCreateDoc, useDeleteDoc } from "@/lib/hooks/useFrappeQuery";
import { erp } from "@/lib/erp";
import type { User } from "@/lib/erp";
import { getQueryOptions } from "@/lib/config/queryConfig";

export function useCurrentUser() {
  return useQuery({
    queryKey: ["users", "current"],
    queryFn: () => erp.users.current(),
  });
}

export function useUserRoles() {
  return useQuery({
    queryKey: ["users", "roles"],
    queryFn: () => erp.users.roles(),
  });
}

export function useUser(name: string) {
  return useQuery({
    queryKey: ["users", "detail", name],
    queryFn: () => erp.users.detail(name),
    enabled: !!name,
    ...getQueryOptions("detail"),
  });
}

export function useUpdateUser(name: string) {
  return useUpdateDoc<User>("User", name);
}

export function useCreateUser() {
  return useCreateDoc<User>("User");
}

export function useDeleteUser() {
  return useDeleteDoc("User");
}
